/**
 * Created by Kevin Dench on 9/14/2016.
 */
/* @ngInject */
export default function SelectedFiltersComponent($scope, $location, SelectedFiltersService, SleuthService, NotifyingService, SpinnerLoadingService, NavigationService,
                                                 ParameterValueModelService, UniquePartModelService, ContainerInfoApiService, CacheService) {

    $scope.selectedFilters = [];
    $scope.hasDetectedSearchComparison = false;

    $scope.init = function () {
        $scope.selectedFilters = SelectedFiltersService.createSelectedFiltersFromSleuthData();
    };

    $scope.init();

    NotifyingService.subscribeToSleuthChanges($scope, $scope.init);
    NotifyingService.subscribeToSleuthDataCache($scope, $scope.init);
    NotifyingService.subscribeToBuilderFilterAction($scope, $scope.init);

    $scope.$watchCollection(
        function () {
            return UniquePartModelService.getCompareQueue();
        },
        function (newComparisons) {
            for (let i = 0; i < newComparisons.length; i++) {
                if (newComparisons[i].type !== undefined) {
                    $scope.hasDetectedSearchComparison = true;
                    return $scope.hasDetectedSearchComparison;
                }
            }
            $scope.hasDetectedSearchComparison = false;
            return $scope.hasDetectedSearchComparison;
        }
    );

    $scope.resetFilters = function () {
        SleuthService.removeSleuthData();
        $scope.selectedFilters.length = 0;
    };

    $scope.onClickRemoveFilter = function (object) {
        SpinnerLoadingService.showLoading();
        $scope.removeFilter(object);
        let parms = [];
        for (let i = 0; i < $scope.selectedFilters.length; ++i) {
            for (let j = 0; j < $scope.selectedFilters[i].parms.length; ++j) {
                parms.push($scope.selectedFilters[i].parms[j]);
            }
        }
        SleuthService.executeParameterValueSearchByParameterValues(parms, function () {
            if ($scope.selectedFilters.length > 0 && $location.path() !== '/browsing') {
                NavigationService.openMenu();
            }
            SpinnerLoadingService.hideLoading();
        });
    };

    $scope.removeFilter = function (value) {
        for (let i = 0; i < $scope.selectedFilters.length; i++) {
            if (value.name === $scope.selectedFilters[i].name && value.parms[0].value === $scope.selectedFilters[i].parms[0].value) {
                $scope.selectedFilters.splice(i, 1);
                break;
            }
        }
    };

    $scope.displayValue = function (parameterValue) {
        if (parameterValue.formattedValue !== undefined && parameterValue.formattedValue !== null) {
            return parameterValue.formattedValue;
        }

        let translatedValue = null;
        if (CacheService.getConfigurationInfo() !== undefined) {
            translatedValue = ContainerInfoApiService.getDisplayName(parameterValue, CacheService.getConfigurationInfo().language);
        }
        if (translatedValue == null) {
            translatedValue = parameterValue.value;
        }
        return translatedValue;
    };
}
